import { Box, Flex } from '@ghq-abi/design-system';

export function SkeletonCard() {
  return (
    <Box
      css={{
        backgroundColor: '$white',
        border: '1px solid #CACDD5',
        borderRadius: '16px',
        padding: '$4',
        boxShadow: '$sm',
        animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
      }}
    >
      <Flex justify="between" align="start">
        <Flex direction="column" css={{ flex: 1 }}>
          <Box
            css={{
              height: '16px',
              backgroundColor: '#E5E7EB',
              borderRadius: '4px',
              width: '70%',
              mb: '$2',
            }}
          />
          <Flex align="center" css={{ mt: '$1' }}>
            <Box
              css={{
                width: '12px',
                height: '12px',
                backgroundColor: '#E5E7EB',
                borderRadius: '50%',
                mr: '$1',
              }}
            />
            <Box
              css={{
                height: '12px',
                backgroundColor: '#E5E7EB',
                borderRadius: '4px',
                width: '80px',
              }}
            />
          </Flex>
        </Flex>
        
        <Box
          css={{
            width: '32px',
            height: '32px',
            backgroundColor: '#E5E7EB',
            borderRadius: '4px',
          }}
        />
      </Flex>
    </Box>
  );
}

export function SkeletonGrid() {
  return (
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '$4',
        mt: '$4',
      }}
    >
      {Array.from({ length: 6 }, (_, index) => `skeleton-card-${Date.now()}-${index}`).map((key) => (
        <SkeletonCard key={key} />
      ))}
    </Box>
  );
}

export function SkeletonList() {
  return (
    <Box css={{ mt: '$4', display: 'flex', flexDirection: 'column', gap: '$3' }}>
      {Array.from({ length: 4 }, (_, index) => `skeleton-list-${Date.now()}-${index}`).map((key) => (
        <Box
          key={key}
          css={{
            height: '100px',
            backgroundColor: '$white',
            border: '1px solid #CACDD5',
            borderRadius: '16px',
            padding: '$4',
            animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
          }}
        >
          <Flex justify="between" align="center">
            <Flex css={{ gap: '$8', flex: 1 }}>
              <Box
                css={{
                  height: '16px',
                  backgroundColor: '#E5E7EB',
                  borderRadius: '4px',
                  width: '150px',
                }}
              />
              <Box
                css={{
                  height: '16px',
                  backgroundColor: '#E5E7EB',
                  borderRadius: '4px',
                  width: '100px',
                }}
              />
              <Box
                css={{
                  height: '16px',
                  backgroundColor: '#E5E7EB',
                  borderRadius: '4px',
                  width: '120px',
                }}
              />
            </Flex>
            <Box
              css={{
                width: '32px',
                height: '32px',
                backgroundColor: '#E5E7EB',
                borderRadius: '4px',
              }}
            />
          </Flex>
        </Box>
      ))}
    </Box>
  );
}
